import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <mask
      id="mask0_534_4289"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="1"
      width="20"
      height="21"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.28662 5C5.80649 4.6375 5.5 4.10595 5.5 3.5C5.5 2.4199 6.47378 1.57621 7.66904 1.50489L7.83333 1.5H8.75C10.5253 1.5 12 2.70659 12 4.25C12 2.828 13.2562 1.68281 14.8684 1.51942L15.056 1.50496L15.25 1.5H16.1667C17.4357 1.5 18.5 2.37081 18.5 3.5C18.5 4.10364 18.1944 4.63631 17.7104 5H20C21.1046 5 22 5.89543 22 7V9C22 9.70291 21.6374 10.3211 21.089 10.6778L21 10.731V11V19C21 20.5977 19.7511 21.9037 18.1763 21.9949L18 22H6C4.34315 22 3 20.6569 3 19V11V10.731L2.91098 10.6778C2.40178 10.3466 2.05275 9.78989 2.00549 9.14926L2 9V7C2 5.89543 2.89543 5 4 5H6.28662ZM19 11V19C19 19.5523 18.5523 20 18 20H14.5V11H19ZM14.5 9H19H20V7H14.5V9ZM13.5 7V20H10.5V7H13.5ZM6 20H9.5V11H5V19C5 19.5523 5.44772 20 6 20ZM9.5 7V9H5H4V7H9.5ZM7.83333 2.5H8.75L8.92036 2.50495L9.09514 2.5205C10.1878 2.65177 11 3.39589 11 4.25V4.5H7.83333L7.69377 4.49457C7.0074 4.44074 6.5 3.99468 6.5 3.5C6.5 2.97234 7.07731 2.5 7.83333 2.5ZM15.2632 2.49982L15.0957 2.50408C13.9612 2.56433 13.0909 3.27497 13.0067 4.11617L13 4.25V4.5L16.1493 4.5003L16.29 4.49571C16.9903 4.44675 17.5 3.99477 17.5 3.5C17.5 3.00532 16.9926 2.55926 16.3062 2.50543L16.1667 2.5L15.2632 2.49982Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_534_4289)">
      <rect width="24" height="24" fill="currentColor" />
    </g>
    <rect x="4.2" y="10.5" width="5.4" height="9.9" fill="currentColor" />
    <rect x="13.8" y="10.5" width="5.4" height="9.9" fill="currentColor" />
  </>
);

const Icon = createSvgIcon(svg, 'CursorArrow');

export default Icon;
